<template>
	<b-form-group
		:label="label"
		:state="state"
	>
    <template #invalid-feedback>
      <span v-html="invalidFeedback" />
    </template>

		<b-form-file
			:accept="accept"
			:browse-text="$t('Please select')"
			:file-name-formatter="formatNames"
			:multiple="multiple"
			:state="state"
			:value="value"
			no-drop
			@input="$emit('input', $event)"
		/>

		<b-list-group v-if="value && value.length > 1" class="mt-2">
			<b-list-group-item
				v-for="file in value"
				:key="file.name"
				class="ml-2 p-1 bg-light"
			>
				{{ file.name }}
			</b-list-group-item>
		</b-list-group>

		<b-progress
			v-if="progress !== null"
			:value="progress"
			animated
			class="mt-1"
		/>
	</b-form-group>
</template>
<script>
export default {

	name: 'FileUploadFormGroup',
	props: {
		accept: {
			type: String,
			default: null
		},
		invalidFeedback: {
			type: String,
			default: null
		},
		label: {
			type: String,
			default() {
				return this.$t('Images')
			}
		},
		multiple: {
			type: Boolean,
			default: true
		},
		progress: {
			type: Number,
			default: null
		},
		state: {
			type: Boolean,
			default: null
		},
		value: {
			type: [Array, File],
			default: () => []
		}
	},
	methods: {
		formatNames(files) {
			if (files.length === 1) {
				return files[0].name
			} else {
				return `${files.length} files selected`
			}
		},
	}
}
</script>
